module.exports = __webpack_public_path__ + "img/tr.6ae13d5.svg";